var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"info"},[_c('a',{staticStyle:{"color":"white"}},[_c('span',[_vm._v(" "+_vm._s(_vm.getFullName)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }